import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import { push } from 'connected-react-router';

import apiAuthCall from 'helpers/apiAuthCall';
import { throttle } from 'helpers/sagaEffects';
import {
    fetchListSuccess,
    actions,
    createCapabilityGroupForm,
    fetchCapabilityGroupSuccess,
    updateCapabilityGroupForm,
} from './duck';
import {
    capabilityGroupsEndpoint,
    updateCapabilityGroupEndpoint,
    getCapabilityGroupEndpoint,
    createCapabilityGroupEndpoint,
    deleteCapabilityGroupEndpoint
} from './selectors';

export function* createCapabilityGroup(api, action) {
    const notificationId = 'createCapabilityGroup';

    try {
        const payload = action.payload;

        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(createCapabilityGroupEndpoint),
                data: payload
            }
        );

        yield put(createCapabilityGroupForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Capability Group'} created!`,
            status: result.status
        }));
        yield put(push(`/admin/capability-groups/${result.data.id}`));
    } catch (err) {
        yield put(createCapabilityGroupForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchCapabilityGroupList(api, action) {
    const notificationId = 'getCapabilityGroupList';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(capabilityGroupsEndpoint)
            }
        );

        yield put(fetchListSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchCapabilityGroup(api, action) {
    const notificationId = action.type;
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(getCapabilityGroupEndpoint, action.payload)
            }
        );

        yield put(fetchCapabilityGroupSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* updateCapabilityGroup(api, action) {
    const notificationId = 'updateCapabilityGroup';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'put',
                url: yield select(updateCapabilityGroupEndpoint, { capabilityGroupId: action.payload.id }),
                data: action.payload
            }
        );

        yield put(updateCapabilityGroupForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Capability Group'} updated!`,
            status: result.status
        }));
        yield put(push('/admin/capability-groups'));
    } catch (err) {
        yield put(updateCapabilityGroupForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* deleteCapabilityGroup(api, confirmMsg, action) {
    const notificationId = 'deleteCapabilityGroup';

    if (!confirmMsg('Are you sure you wish to delete this capability group?')) { // eslint-disable-line no-alert
        return;
    }

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'delete',
                url: yield select(deleteCapabilityGroupEndpoint, { capabilityGroupId: action.payload.id }),
                data: action.payload
            }
        );

        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Capability Group'} deleted!`,
            status: result.status
        }));
        yield put(push('/admin/capability-groups'));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}


export default function* capabilityGroupSaga({ api }) {
    yield all([
        takeLatest(createCapabilityGroupForm.REQUEST, createCapabilityGroup, api),
        takeLatest(updateCapabilityGroupForm.REQUEST, updateCapabilityGroup, api),
        throttle(200, actions.FETCH_CAPABILITY_GROUP_LIST, fetchCapabilityGroupList, api),
        takeLatest(actions.FETCH_CAPABILITY_GROUP, fetchCapabilityGroup, api),
        takeLatest(actions.DELETE_CAPABILITY_GROUP, deleteCapabilityGroup, api, window.confirm),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/capabilityGroups/saga.js